const TiposOrigem = {
   lojaCambioWeb: 3
}

export default TiposOrigem;